import common from '../../common';

const _onStamp_Changed = Symbol('_onStamp_Changed');

export default class Stamp {
	constructor() {
		// Attributes.
		this._drawLayer = null;
		this._paletteItem = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;
		this._paletteItem = common.gameConfig.palettePanel.pages[common.gameConfig.palettePanel.tools.stamp[0]][0];
		// Listen to HUD controls.
		common.game.scene.palettePanel.signals.onStampChanged.add(this[_onStamp_Changed], this);
	}

	onDrawBegan(point) {
		let sprite = new PIXI.Sprite(P3.assets.texture(this._paletteItem));
		sprite.position.set(point.x + 325, point.y);
		this._drawLayer.addChild(sprite);
		common.gameScene.allStamps.push(sprite);

		// Sfx.
		P3.audio.playSound('sfx_tool_stamp_use_00');
	}

	onDrawMoved(from, to) {
	}

	onDrawEnded() {
	}

	[_onStamp_Changed](selection) {
		this._paletteItem = selection;
	}

	get paletteItem() {
		return this._paletteItem;
	}
}
